import LogosCarousel, { Logo } from "../../components/LogosCarousel/LogosCarousel"
import styles from "../insurances/insurances_and_famousFrom.module.scss"
import StyledText from "../../typography/typography-component"
import skColors from "../../../styles/skColors"
import { useTranslations } from "next-intl"

const FamousFrom = () => {
  const t = useTranslations("index")
  const famousFromLogos: Logo[] = [
    {
      src: "/images/famous_from/aerzte_zeitung.png",
      alt: "Ärztezeitung",
    },
    {
      src: "/images/famous_from/handelsblatt.png",
      alt: "Handelsblatt",
    },
    {
      src: "/images/famous_from/psoriasis_netz.png",
      alt: "Psoriasisnetz",
    },
    {
      src: "/images/famous_from/springer_medizin.png",
      alt: "Springer Medizin",
    },
    {
      src: "/images/famous_from/weser_kurier.png",
      alt: "Weserkurier",
    },
  ]

  return (
    <section className={styles.famousFrom} id={"famousFrom"}>
      <StyledText color={skColors.turquoise[600]} variant={"h2"}>
        {t("famousFrom.title")}
      </StyledText>
      <LogosCarousel className={styles.logoCarouselFamousFrom} logos={famousFromLogos} />
    </section>
  )
}

export default FamousFrom
